module.exports = __webpack_public_path__ + "static/media/gaming14.f5c6a18d.webp";